var map = {
	"./a2.png": 627,
	"./a3.png": 522,
	"./a4.png": 293,
	"./b2.png": 374,
	"./b3.png": 367,
	"./b4.png": 752,
	"./background.png": 194,
	"./bass-clef.png": 141,
	"./c2.png": 933,
	"./c3.png": 308,
	"./c4.png": 707,
	"./d2.png": 64,
	"./d3.png": 105,
	"./d4.png": 542,
	"./e2.png": 615,
	"./e3.png": 390,
	"./f2.png": 418,
	"./f3.png": 419,
	"./flat.png": 915,
	"./g1.png": 882,
	"./g2.png": 65,
	"./g3.png": 160,
	"./lines-minus-1.png": 868,
	"./lines-minus-2.png": 983,
	"./lines-plus-1.png": 37,
	"./lines-plus-2.png": 953,
	"./lines.png": 173,
	"./sharp.png": 487,
	"./treble-clef.png": 275,
	"./whole-note.png": 660
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 452;